import { render } from "./Create.vue?vue&type=template&id=0c9cb440&scoped=true"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"

import "./Create.vue?vue&type=style&index=0&id=0c9cb440&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0c9cb440"

export default script